import { useEffect, useRef } from 'react';

function useEventListener(eventName, handler, element) {
  var savedHandler = useRef();
  useEffect(function () {
    var targetElement = (element === null || element === void 0 ? void 0 : element.current) || window;

    if (!(targetElement && targetElement.addEventListener)) {
      return;
    }

    if (savedHandler.current !== handler) {
      savedHandler.current = handler;
    }

    var eventListener = function eventListener(event) {
      if (!!(savedHandler !== null && savedHandler !== void 0 && savedHandler.current)) {
        savedHandler.current(event);
      }
    };

    targetElement.addEventListener(eventName, eventListener);
    return function () {
      targetElement.removeEventListener(eventName, eventListener);
    };
  }, [eventName, element, handler]);
}

export default useEventListener;